<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建网关</h1>
        <h1 v-if="flag == 'edit'">更新网关</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">创建网关的文字介绍。</h3>
          <h3 v-if="flag == 'edit'">网关的文字介绍。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <!-- <el-form-item label="通信类型" prop="commuType"><br />
            <el-radio-group v-model="addForm.commuType" :disabled="this.flag == 'edit'">
              <el-radio :label="1">tcp</el-radio>
              <el-radio :label="2">udp</el-radio>
              <el-radio :label="3">mqtt</el-radio>
              <el-radio :label="4">coap</el-radio>
              <el-radio :label="5">http</el-radio>
            </el-radio-group>
            <br />
          </el-form-item> -->
          <el-form-item label="用户名" prop="mqttUsername" v-if="this.commuType == 3"><br />
            <el-input v-model="addForm.mqttUsername" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="mqttPassword" v-if="this.commuType == 3"><br />
            <el-input v-model="addForm.mqttPassword" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name"><br />
            <div class="subheading">输入网关名称，方便辨别网关。</div>
            <el-input v-model="addForm.name" placeholder="请输入" maxlength="250"></el-input>
          </el-form-item>
          <el-form-item label="网关编号" prop="code"><br />
            <div class="subheading">
              网关编号必须与网关连接时上报的注册码一致，建议填写网关的IMEI号。
            </div>
            <el-input v-model="addForm.code" placeholder="请输入" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="网关协议" prop="mduProtocolId"><br />
            <div>
              <br />
              <el-select v-model="addForm.mduProtocolId" filterable placeholder="未选择">
                <el-option v-for="item in mduProtocolIdList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="briefBtn" @click="addProtocol">创建协议</el-button>
            </div>
          </el-form-item>
          <el-form-item label="离线检测时间间隔（min）" prop="offlineCheckInterval" v-if="this.commuType != 3"><br />
            <div class="subheading">离线检测间隔，用于定时检测网关在线状态。<span style="margin-left:5px;color:#E6A23C">要求离线检测时间间隔在 10 -
                129,600 分钟之内</span></div>
            <el-input v-model.number="addForm.offlineCheckInterval" placeholder="请输入离线检测时间间隔">
              <template slot="append">分钟</template>
            </el-input>
            <span style="margin-left:30px;line-height:40px;height:40px; margin-top:10px;display:inline-block;">
              快速输入：
              <el-link :underline="false" type="primary" @click="addForm.offlineCheckInterval = 720">12小时</el-link>
              <el-link style="margin-left:18px" :underline="false" type="primary"
                @click="addForm.offlineCheckInterval = 1440">1 天</el-link>
              <el-link style="margin-left:18px" :underline="false" type="primary"
                @click="addForm.offlineCheckInterval = 10080">1 周</el-link>
              <el-link style="margin-left:18px" :underline="false" type="primary"
                @click="addForm.offlineCheckInterval = 43200">1 月</el-link>
            </span>
          </el-form-item>
          <div @click="showMore = !showMore"
            style="height:50px;line-height: 50px;padding-left: 20px;color: #409EFF;cursor: pointer;">
            更多设置
            <i v-if="!showMore" class="el-icon-arrow-down el-icon--right" style="margin-left: -2px;"></i>
            <i v-if="showMore" class="el-icon-arrow-up el-icon--right" style="margin-left: -2px;"></i>
          </div>

          <div v-show="showMore">
            <el-form-item label="品牌" prop="brand"><br />
              <div class="subheading">请选择网关品牌，可搜索后选择。</div>
              <el-select v-model="addForm.brand" filterable placeholder="未选择" @change="brandChange">
                <el-option v-for="item in brandList" :key="item.id" :label="item.content" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="型号" prop="model"><br />
              <div class="subheading">请选择网关型号，可搜索后选择。</div>
              <el-select v-model="addForm.model" filterable placeholder="未选择" @change="modelChange">
                <el-option v-for="item in modelList" :key="item.id" :label="item.content" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="北向联网方式" prop="northLinkType"><br />
              <div class="subheading">
                请选北向联网方式，即网关给云平台上传数据的方式，可多选。
              </div>
              <div class="checkeds">
                <el-checkbox-group v-model="addForm.northLinkType">
                  <el-checkbox v-for="val in northLinkType" :key="val.id" :label="val.id" border>{{ val.content }}
                  </el-checkbox>
                </el-checkbox-group>

              </div>
            </el-form-item>
            <el-form-item label="南向联网方式" prop="southLinkType"><br />
              <div class="subheading">
                请选南向联网方式，即网关提供给设备的连接方式，可多选。
              </div>
              <div class="checkeds">
                <el-checkbox-group v-model="addForm.southLinkType">
                  <el-checkbox v-for="(val, index) in southLinkType" :key="index" :label="val.id" border>
                    {{ val.content }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="操作系统" prop="os"><br />
              <div class="subheading">请选择网关操作系统。</div>
              <el-select v-model="addForm.os" filterable placeholder="未选择">
                <el-option v-for="item in osList" :key="item.id" :label="item.content" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="加密类型" prop="encryptType"><br />
              <div class="subheading">请选择加密类型</div>
              <el-select v-model="addForm.encryptType" filterable placeholder="未选择">
                <el-option v-for="item in encryptTypeList" :key="item.id" :label="item.content" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SIM卡ICCID" prop="simIccid"><br />
              <div class="subheading">
                可输入网关内SIM卡ICCID，以获取SIM卡使用状态。
              </div>
              <el-input v-model="addForm.simIccid" placeholder="请输入" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks" style="background-color:#fff"><br />
              <div class="subheading">根据需要，输入网关备注信息。</div>
              <el-input type="textarea" :rows="3" v-model="addForm.remarks" placeholder="请输入" maxlength="255">
              </el-input>
            </el-form-item>
          </div>


          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm')">创建网关</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit('addForm')">更新网关</el-button>
          </el-form-item>


        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        commuType: sessionStorage.getItem('commuType'),
        routeList: this.$route.meta.routeList,
        flag: this.$route.query.flag,
        rules: {
          name: [{
            required: true,
            message: "请输入网关名称",
            trigger: "blur"
          }],
          code: [{
              required: true,
              message: "请输入网关编号",
              trigger: "blur"
            },
            {
              max: 100,
              message: '长度在100以内',
              trigger: 'blur'
            },
            {
              pattern: /^[A-Za-z0-9_-]+$/,
              message: '只能输入大小写字母和数字以及"-"或"_"'
            }
          ],
          offlineCheckInterval: [{
              required: true,
              message: "请输入离线检测时间间隔",
              trigger: "blur"
            },
            {
              min: 10,
              max: 129600,
              type: 'number',
              message: '只能输入10-129600之间的整数'
            }
          ]
        },
        addForm: {
          northLinkType: [],
          southLinkType: [],
          model: "",
          mduProtocolId: "",
          offlineCheckInterval: 10,
          type: 1,
          encryptType: 0,
        },
        showMduProtocolId: true,
        agreementList: [], //推荐网关协议数据
        northLinkType: [], //北向联网方式数据
        southLinkType: [], //南向联网方式数据
        mduProtocolIdList: [], //网关协议下拉数据
        osList: [], //操作系统下拉
        encryptTypeList: [{
            id: 0,
            content: '不加密'
          },
          {
            id: 1,
            content: 'sm2'
          }
        ],
        brandList: [], //品牌下拉数据
        brandId: "", //存着当前品牌的id,为了获取推荐协议里面使用
        modelList: [], //型号下拉数据
        showMore: false //默认不显示更多
      };
    },
    created() {},
    methods: {

      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        //获取网关协议
        this.getProtocolList();
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          API.platformMduModule(id).then(res => {
            if (res.code == 1) {
              if (res.data.southLinkType != null) {
                res.data.southLinkType = res.data.southLinkType.split(",");
              }
              if (res.data.northLinkType != null) {
                res.data.northLinkType = res.data.northLinkType.split(",");
              }
              //根据品牌获取型号下拉数据
              API.platformMduModuleModelList(res.data.brand).then(res => {
                if (res.code == 1) {
                  this.modelList = res.data.dictionaryList;
                }
              });
              this.addForm = res.data;
              if (!this.addForm.northLinkType) {
                this.addForm.northLinkType = []
              }
              if (!this.addForm.southLinkType) {
                this.addForm.southLinkType = []
              }


            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      },
      //获取所有新增页面所有的数据
      getData() {
        API.platformMduModuleAddData().then(res => {
          if (res.code == 1) {
            this.brandList = res.data.dictionaryList.moduleBrand; //品牌下拉数据
            this.osList = res.data.dictionaryList.os;
            this.southLinkType = res.data.dictionaryList.southLinkType;
            this.northLinkType = res.data.dictionaryList.northLinkType;
          }
        });
      },
      //根据品牌下拉数据获取型号
      brandChange(val) {
        this.brandId = val; //把id存起来，为了获取推荐协议里面使用
        this.addForm.model = ""; //品牌改变，型号清空
        API.platformMduModuleModelList(val).then(res => {
          if (res.code == 1) {
            this.modelList = res.data.dictionaryList;
          }
        });
      },
      //根据品牌型号，获取推荐协议
      modelChange(val) {
        //传品牌id，跟型号id
        API.platformMduModuleModuleProtocol(this.brandId, val).then(res => {
          if (res.code == 1) {
            this.agreementList = res.data.protocolList;
          }
        });
      },
      //查询网关协议下拉数据
      getProtocolList() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformMduModuleModuleProtocolList(param).then(res => {
          if (res.code == 1) {
            this.mduProtocolIdList = res.data.protocolList;
          }
        });
      },
      //创建网关
      onSubmit(formName) {
        let _this = this;
        let _API = API;
        this.addForm.commuType = sessionStorage.getItem('commuType');
        this.$refs[formName].validate(valid => {
          if (valid) {
            _API.addPlatformMduModule(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建网关成功",
                  type: "success"
                });
                var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                  "openNoviceGuide") : "false";
                var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                  "noviceGuideStep") : '0';
                if (openNoviceGuide == "true" && noviceGuideStep == '1') {
                  this.changeNoviceGuideStep('noviceGuideStep', 2);
                  //页面跳转
                  this.$router.push({
                    path: "/equipment/equimentProtocolAdd",
                  });
                } else {
                  _this.$router.push({
                    path: "/device/moduleManagement"
                  });
                }
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
      //创建协议
      addProtocol() {
        this.$router.push({
          path: "/device/protocolAdd",
          query: {
            data: JSON.stringify(this.addForm)
          }
        });
      },
      moduleProtocolDetailsBtn(id) {
        const ids = id;
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: ids
          }
        });
      },
      //更新网关
      editOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            _API
              .editPlatformMduModule(this.$route.query.id, _this.addForm)
              .then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: "更新网关成功",
                    type: "success"
                  });
                  _this.$router.push({
                    path: "/device/moduleManagement"
                  });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      }
    },
    mounted() {
      this.getData();
      this.getMage();
      if (this.$route.params.data) {
        this.addForm = JSON.parse(this.$route.params.data)
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/moduleAdd.vue